import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserPermission } from '../constants/Types';

type State = {
  firstName: string | null;
  lastName: string | null;
  acceptedTerms: boolean;
  isAdmin: boolean;
  permissions: UserPermission[];
  enabledFeatures: {
    chatbot: boolean;
  };
};

const initialState: State = {
  firstName: null,
  lastName: null,
  acceptedTerms: false,
  isAdmin: false,
  permissions: [],
  enabledFeatures: {
    chatbot: false,
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUsername(state: State, action: { payload: { firstName, lastName } }) {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
    },
    updateTermsAccepted(state: State, action: { payload: boolean }) {
      state.acceptedTerms = action.payload;
    },
    updateIsAdmin(state: State, action: { payload: boolean }) {
      state.isAdmin = action.payload;
    },
    setPermissions(state, action: PayloadAction<UserPermission[]>) {
      state.permissions = action.payload;
    },
    addPermission(state, action: PayloadAction<UserPermission>) {
      if (!state.permissions.includes(action.payload)) {
        state.permissions.push(action.payload);
      }
    },
    removePermission(state, action: PayloadAction<UserPermission>) {
      state.permissions = state.permissions.filter((p) => p !== action.payload);
    },
    setChatbotEnabled(state, action: PayloadAction<boolean>) {
      if (!state.enabledFeatures) {
        state.enabledFeatures = { chatbot: false };
      }
      state.enabledFeatures.chatbot = action.payload;
    },
  },
});

export const {
  updateUsername, updateTermsAccepted, updateIsAdmin, setPermissions,
  addPermission, removePermission, setChatbotEnabled,
} = userSlice.actions;

export default userSlice.reducer;
